import { useDispatch } from "react-redux";
import { ScheduleGrid } from "./ScheduleGrid";
import { useEffect } from "react";
import { setPageTitle } from "../../../store/slices/pageTitleSlice";


export const Schedule = () => {
  const dispatch = useDispatch();
    useEffect( () => {
        dispatch(setPageTitle('Schedule | Spire360'));
    }, []);
  return (
    <>
      <ScheduleGrid breadcrumbs={true} scope="Global"></ScheduleGrid>
    </>
  );
};